angular.module('app').config(creditNotesRouting);

function creditNotesRouting($routeProvider) {
  $routeProvider
    .when('/credit_notes', {
      pageTitle: 'CREDIT_NOTES',
      template: '<credit-notes-page></credit-notes-page>',
      accessPermission: 'index_creditnote_accountadmin',
      current: 'credit_notes',
      authReq: true,
    })
    .when('/credit_notes/new', {
      params: {
        invoiceId: null,
        invoiceNumber: null,
        clientId: null,
      },
      pageTitle: 'ADD_CREDIT_NOTE',
      template: '<credit-note-page></credit-note-page>',
      breadcrumb: {
        label: 'CREDIT_NOTES',
        parent: 'credit_notes',
        ajs: true,
      },
      accessPermission: 'create_creditnote_accountadmin',
      authReq: true,
    })
    .when('/credit_notes/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'CREDIT_NOTE',
      template: '<credit-note-page></credit-note-page>',
      breadcrumb: {
        label: 'CREDIT_NOTES',
        parent: 'credit_notes',
        ajs: true,
      },
      accessPermission: 'show_creditnote_accountadmin',
      authReq: true,
    });
}

creditNotesRouting.$inject = ['$routeProvider'];
